import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';

// SteamNews 下载列配置
const columns = [
  // 额外指定的 NO. 列，及需手动添加的 number 字段
  {
    title: 'NO.',
    key: 'number',
  },
  {
    title: 'title',
    key: 'name',
  },
  {
    title: 'category',
    key: 'event_type',
  },
  {
    title: 'release_time',
    key: 'start_time',
  },

  {
    title: 'content',
    key: 'description',
  },
  {
    title: 'url',
    key: 'url',
  },
];

// 从 downloadAction 方法 downloadParams 参数中获取 fileName 文件名属性
function getDownloadParams(params: Record<string, any>) {
  return { $$fileName: params.fileName };
}

// 给数据加一个 number 属性
export function addNumberColumn({
  list,
  page,
  page_size,
}: {
  list: Record<string, any>;
  page: number;
  page_size: number;
}) {
  return {
    Sheet1: list?.map((item: any, index: number) => ({
      ...item,
      number: (page - 1) * page_size + index + 1,
    })),
  };
}

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    sheetName: ['Sheet1'],
    Sheet1: columns,
    // steamNews 下载查询方法
    downloadFetchApi: '/api/v1/intelligence_pc/detail/game_steam_news',
    // 返回数据中取值字段名
    dataKey: ['game_events'],
    // 是否有 number 列，需要调用对应方法处理数据
    hasNumberColumn: true,
    fParams: {
      page: 1,
      page_size: 1000,
      event_types: [],
      sources: ['steam'],
      entity_type: 'combine',
    },
    ...getDownloadParams(params),
  };
};
